import BaseInput from './base_input.vue'

export default {
    install(Vue: { component: (componentName: string, component: object) => object }) {
        Vue.component('BaseInput', BaseInput)
    }
}
